import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';
import * as icons from 'mdi-material-ui';

const containerSx = disableBorder => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '16px',
    padding: 3,
    minHeight: '80.5px',
    flexShrink: 0,
    ...(!disableBorder && { borderBottom: '1px solid #ccc', boxShadow: '0 1px #ccc' }),
});

const iconBoxSx = theme => ({
    borderRadius: '20px',
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: 'pointer',
    fontSize: '23px',
    width: '30px',
    height: '30px',
    color: 'primary.main',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const CustomDialogTitle = props => {
    const { handleClose, hideClose = false, title = ' ', disableBorder } = props;

    return (
        <Box sx={containerSx(disableBorder)}>
            <Typography sx={{ flex: '1 1', color: 'common.black' }}>{title}</Typography>
            {!hideClose && (
                <Box onClick={handleClose} sx={iconBoxSx}>
                    <icons.Close sx={{ fontSize: '16px' }} />
                </Box>
            )}
        </Box>
    );
};

CustomDialogTitle.propTypes = {
    title: PropTypes.node,
    handleClose: PropTypes.func,
    hideClose: PropTypes.bool,
    disableBorder: PropTypes.bool,
};

export default CustomDialogTitle;
